import { User } from '@ha/api/v2/types/User';
import {
  ProfileEditActionTypes as ActionTypes,
  ProfileEditActions,
} from 'ha/modules/AuthLogic/constants';

interface Result {
  type: ActionTypes;
  error: boolean;
  payload: object;
}

export function updateUserProfile(payload: Partial<User>): Result {
  return {
    type: ProfileEditActions.UPDATE_USER,
    error: false,
    payload,
  };
}
